<template>
  <sfs-form-modal
    :id="modalId"
    title="Add a GL Code"
    @on-hide="resetFormData"
  >
    <gl-code-form
      :organization="organization"
      :organization_id="organization_id"
      @on-submit="createGlCode"
      @on-save="onSave"
      @on-cancel="closeModal"
      :key="formKey"
    />
  </sfs-form-modal>
</template>

<script>
import GlCodeForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'GlCodesAddModal',
  mixins: [formModalMixin],
  components: {
    GlCodeForm,
  },
  data() {
    return {
      modalId: 'gl-code-add-modal',
    };
  },
  methods: {
    createGlCode(data, handleCreate) {
      handleCreate(this.$glCodesAPI.create(data));
    },
    onSave() {
      this.closeModal();
      this.$emit('on-save');
    },
  },
  computed: {
    organization() {
      return this.$store.getters.currentOrganization;
    },
    organization_id() {
      return this.organization?.id;
    },
  },
};
</script>
